import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import PrivateDepartureMessagingTile from './PrivateDepartureMessagingTile'
import TailorMadeTourMessagingTile from './TailorMadeTourMessagingTile'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getIsPrivateRequestEnabled } from 'selectors/TourV2/tourV2OfferPageSelectors'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(12)};

  ${mediaQueryUp.tablet} {
    gap: ${rem(24)};
    grid-template-columns: repeat(auto-fill, minmax(${rem(400)}, 1fr));
  }
`

interface MappedStateProps {
  offer: Tours.TourV2Offer
  selectedVariation: Tours.TourV2OfferVariation
  isPrivateRequestEnabled: boolean
}

function AdditionalWaysToExperienceSection({ offer, selectedVariation, isPrivateRequestEnabled }: MappedStateProps) {
  return <Container>
    <TailorMadeTourMessagingTile tourOffer={offer} tourOfferVariation={selectedVariation} />
    {isPrivateRequestEnabled && <PrivateDepartureMessagingTile offer={offer} />}
  </Container>
}

export default withOfferPageAndReduxState((offerPageState: OfferPageState, appState: App.State): MappedStateProps => {
  return {
    offer: offerPageState.tourV2Offer!,
    selectedVariation: offerPageState.tourV2Variation!,
    isPrivateRequestEnabled: getIsPrivateRequestEnabled(offerPageState, appState),
  }
})(AdditionalWaysToExperienceSection)
